import Address from '@/classes/addresses/Address'

export default class OpenStreetMapAddress extends Address {
  constructor ({ address = {}, lat = null, lon = null, display_name = null, type, addresstype, category } = {}) {
    super({
      line1: address.road,
      number: address.house_number,
      city: address.village || address.city || address.town,
      state: address.state,
      postal_code: address.postcode,
      country: address.country_code?.toUpperCase(),
      latitude: lat,
      longitude: lon
    })

    this.display_name = display_name
    this.type = type
    this.addresstype = addresstype
    this.category = category
  }

  get types () {
    const types = []

    const city_types = ['city', 'town', 'village']
    const region_address_types = ['state', 'county', 'region', 'municipality', 'postcode', 'city_district']
    const address_types = ['house', 'residential', 'building']

    if (city_types.includes(this.type) || city_types.includes(this.addresstype)) types.push('(cities)')
    if (this.category === 'boundary' && this.type === 'administrative' && region_address_types.includes(this.addresstype)) types.push('(regions)')
    if (address_types.includes(this.type) || address_types.includes(this.addresstype)) types.push('address')

    return types
  }
}